import { makeStyles } from 'beam'
import { ReactElement, ReactNode } from 'react'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
    '&:first-child': {
      marginTop: 0,
    },
    '& > *': {
      marginLeft: theme.spacing(2),
      '&:first-child': {
        marginLeft: 0,
      },
    },
  },
}))

export interface RowProps {
  children: ReactNode,
}

export function Row({ children }: RowProps): ReactElement {
  const classes = useStyles()
  return <div className={classes.root}>{children}</div>
}
